import { apiSlice } from 'state/slices/apiSlice';

const SHIFTS_URL = '/shifts';

export const shiftApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createShift: builder.mutation({
      query: (shiftData) => ({
        url: `${SHIFTS_URL}/create`,
        method: 'POST',
        body: shiftData,
        transformResponse: (response) => response.json(),
      }),
    }),
    getShifts: builder.query({
      query: () => `${SHIFTS_URL}/list`,
    }),
    updateShift: builder.mutation({
      query: (data) => {
        return {
          url: `${SHIFTS_URL}/update`,
          method: 'PUT',
          body: { ...data },
        };
      },
    }),
    deleteShift: builder.mutation({
      query: (id) => ({
        url: `${SHIFTS_URL}/delete`,
        method: 'DELETE',
        body: { id }
      }),
    }),
  }),
});

export const {
  useCreateShiftMutation,
  useGetShiftsQuery,
  useUpdateShiftMutation,
  useDeleteShiftMutation,
} = shiftApiSlice;
